import OAuthHandler from '../../auth/components/OAuthHandler';

export default function AuthenticatePage() {
    return <OAuthHandler />;
}
